import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { formatGBP } from "../../leak detection/helper/helperFunctions";

const PendingRejectTable = ({
  dashBoardData,
  userPendings,
  userRejected,
  showAnimation,
}: any) => {
  const combinedData =
    dashBoardData &&
    dashBoardData[userPendings].map((pending: any) => {
      const rejected = dashBoardData[userRejected].find(
        (rej: any) => rej.displayname === pending.displayname
      ) || { rejectedapprovel: "0", rejectedAmount: "£0.00 , €0.00" };

      const formatAmount = (amount: string) => {
        const trimmedAmount = amount.trim();

        if (trimmedAmount === ",") {
          return "0";
        }

        // If the amount has a valid currency format (like "€ 258 , £ 822"), return as is.
        if (trimmedAmount.match(/^[€£$]\s*\d+(?:\s*,\s*[€£$]\s*\d+)*$/)) {
          return trimmedAmount;
        }

        // Handle cases where amount starts or ends with ","
        return trimmedAmount.replace(/^,\s*|\s*,\s*$/g, "");
      };

      return {
        displayname: pending.displayname,
        pendingapprovel: pending.pendingapprovel,
        pendingAmount: formatAmount(pending.pendingAmount),
        rejectedapprovel: rejected.rejectedapprovel,
        rejectedAmount: formatAmount(rejected.rejectedAmount),
      };
    });

  const handleShowAmountInGBP = (rowData: any, type: string) => {
    const amount = rowData[type];
    return amount
      .split(",")
      .map(
      (joinedAmount: any, index: number) =>
        `${
        index === 0 ? joinedAmount.slice(0, 1) : joinedAmount.slice(1, 2)
        } ${formatGBP(joinedAmount.trim().slice(1))}`
      )
      .join(", ");
  };

  const pendingRejectColumns: ColumnOption[] = [
    { field: "displayname", header: "User", visible: true },
    { field: "pendingapprovel", header: "Pending Invoices", visible: true },
    {
      field: "pendingAmount",
      header: "Pending Amount",
      body: (e: any) => handleShowAmountInGBP(e, "pendingAmount"),
      visible: true,
    },
    { field: "rejectedapprovel", header: "Rejected Invoices", visible: true },
    {
      field: "rejectedAmount",
      header: "Rejected Amount",
      body:  (e: any) => handleShowAmountInGBP(e, "rejectedAmount"),
      visible: true,
    },
  ];

  return (
    <div className={`${showAnimation ? "flipRightToLeft" : ""}`}>
      <DataTableComponent
        rowData={combinedData}
        columns={pendingRejectColumns}
      />
    </div>
  );
};

export default PendingRejectTable;
